import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { MatTableModule } from '@angular/material/table';
import { MatRippleModule } from '@angular/material/core';
import { ToggleMenuButtonComponent } from './toggle-menu-button.component';

@NgModule({
  declarations: [ToggleMenuButtonComponent],
  imports: [
    CommonModule,
    IonicModule,
    MatTableModule,
    TranslateModule.forChild({}),
    MatRippleModule,
  ],
  exports: [ToggleMenuButtonComponent],
  providers: [],
})
export class ToggleMenuButtonModule {}
